import { render } from "./SkillsView.vue?vue&type=template&id=2da38c0e&scoped=true"
import script from "./SkillsView.vue?vue&type=script&lang=js"
export * from "./SkillsView.vue?vue&type=script&lang=js"

import "./SkillsView.vue?vue&type=style&index=0&id=2da38c0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da38c0e"]])

export default __exports__